
export default {
	name: 'choosePop',
	props: {
		tempId: String
	},
	data() {
		return {
			dialogVisible: false,
			getParams: {},
			unbindGoodsList: [],
            gameStr: ''
		}
	},
	methods: {
		handleClose() {
			this.dialogVisible = false
		},
		async getUnBindConjoinedGoods() {
			const res = await this.$api.unionUnBindOptionsApi({ isBind: false, ...this.getParams })
			if (!res.success) {
				return this.$message.error(res.info)
			}
			this.unbindGoodsList = res.data
            if(this.unbindGoodsList.length === 0){
                const res1 = await this.$api.publicGameName({ gameId: this.getParams.gameId });
                this.gameStr = res1.data;

            }
		},
		async openDialog(data) {
			this.getParams = data
			await this.getUnBindConjoinedGoods()
			this.dialogVisible = true
		},
		onChooseGoods(data) {
			this.dialogVisible = false
			this.$emit('chooseGoods', data)
		},
        goToPublish(){
            this.$router.push(`/selectGame`)
        }
	}
}
